module.exports = __webpack_public_path__ + "img/DSC_0028.094f1a05.jpg";